import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

class CurriculumVitae extends Component {
	state = {
		numPages: null,
		pageNumber: 1
	};

	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	};

	componentDidMount() {
		pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
	}
	render() {
		//const { pageNumber, numPages } = this.state;

		return (
			<div className='row justify-content-md-center cv'>
				<Document
					file='images/DK_CV.pdf'
					onLoadSuccess={this.onDocumentLoadSuccess}
				>
					{[1, 2, 3, 4].map((page) => (
						<Page pageNumber={page} />
					))}
				</Document>
			</div>
		);
	}
}

export default CurriculumVitae;
